module.exports = __webpack_public_path__ + "static/img/productImg.c8ccc9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productImg.png
// module id = Ms1A
// module chunks = 1